import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType, concatLatestFrom } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { AuthTokenActions } from './auth-token.actions';
import { VaSessionService } from '../../services/va-session.service';
import { ChatAdminActions } from '../chat-admin/chat-admin.actions';
import { Store } from '@ngrx/store';
import { selectContext } from '../window-messages/window-messages.reducer';
import { selectUserName } from '../user-info/user-info.reducer';

@Injectable({
  providedIn: 'root',
})
export class AuthTokenEffects {
  constructor(
    private readonly actions$: Actions,
    private vaSessionService: VaSessionService,
    private store: Store
  ) {}
  /**
   * Creates the start session effect
   */
  startSession$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthTokenActions.startSession),
      concatLatestFrom(() => this.store.select(selectUserName)),
      switchMap(([, userName]) =>
        this.vaSessionService.startSession(userName).pipe(
          map((result: any) => {
            return AuthTokenActions.startSessionSuccess({
              token: result.token,
              expiryDate: result.expiryDate,
              sessionIdentifier: result.sessionIdentifier,
            });
          }),
          catchError(() => of(AuthTokenActions.handleSessionFailure()))
        )
      )
    )
  );

  callChatAdmin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthTokenActions.startSessionSuccess),
      concatLatestFrom(() => this.store.select(selectContext)),
      map(([, context]) => {
        return ChatAdminActions.callCustomerJourney({
          contextName: context,
          isFirstCall: true,
        });
      })
    )
  );
}
